export default "__VITE_ASSET__6a4d3fa3__"